var _module_exports = "<div class=\"row\"><div class=\"col-md-6\"><p>{{vm.schema.title}}</p></div><div class=\"col-md-6\"><div class=\"text-right\"><span class=\"glyphicon glyphicon-plus m-l-md\" data-ng-click=\"vm.addComponent($event)\"></span> <span class=\"glyphicon glyphicon-trash m-l-md\" data-ng-click=\"vm.removeComponent($event)\"></span></div></div></div>";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/schema/schema.header.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/schema/schema.header.html
// module id = 914
// module chunks = 0